import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { SearchAlignmentStylesApiRequest } from '../../../types/requests/alignment-styles/search-alignment-styles.request';
import { AlignmentStyleApiModel } from '../../../types/models/alignment-style.model';

export const searchAlignmentStyles = <T extends AlignmentStyleApiModel>(params: SearchAlignmentStylesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/alignment-styles`, { params });
